class FocusDriver

  @DEFAULTS:
    popover:
      autohide: false
      position: 'bottom-center'

  constructor: (options) ->
    @_buildOptions(options)
    @_selectElements()
    @_bind()
    @$element.data('focus-driver', @)

  _buildOptions: (options) ->
    @options = Object.assign {}, @constructor.DEFAULTS, options

    if @options.popover.cls
      @options.popover.cls += ' focus-driver-popover'
    else
      @options.popover.cls = 'focus-driver-popover'

  _selectElements: ->
    @$element = $(@options.element)

  _bind: ->
    @$element
      .on 'click.focusDriver', =>
        @destroy()

  _unbind: ->
    @$element
      .off('.focusDriver')

  show: ->
    return if @$element.is(':hidden')
    $('body').append('<div class="focus-driver-overlay"></div>')
    @$element.addClass('focus-driver-highlight')
    @options.popover.pointTo = @$element
    @popover = simple.popover(@options.popover)

  destroy: ->
    $('body').find('.focus-driver-overlay').remove()
    @$element.removeClass('focus-driver-highlight')
    @popover.destroy()
    @$element.trigger('done.focusDriver')
    @_unbind()


$ ->
  $(document)
    .on 'click', '.js-destroy-focus-driver', (e) ->
      popover = $(e.currentTarget).closest('.focus-driver-popover').data('popover')
      focusDriver = popover.pointTo.data('focus-driver')
      focusDriver.destroy()


tower.focusDriver = (options) ->
  new FocusDriver(options)
